module.exports = __webpack_public_path__ + "media/images/pr_detail/Vector-2c4ef2611adcc836b1b77d2fa53fda44.png";